import { Textarea } from "@/components/ui/textarea";

import SharedEndDatePicker from "./SharedEndDatePicker";
import type { ReasonPanelProps } from "./reasonPanel.types";

export default function RetirementReasonPanel({
  joiningDate,
  resignationDate,
  onResignationDateChange,
  isEndDateError,
  memo,
  onMemoChange,
  disabled,
  occupiedRanges,
}: ReasonPanelProps) {
  return (
    <div className="flex flex-col gap-3 pt-2">
      <SharedEndDatePicker
        label="퇴사일"
        // description="퇴사일 이후 자동 제외"
        required
        joiningDate={joiningDate}
        value={resignationDate}
        onChange={onResignationDateChange}
        isError={isEndDateError}
        disabled={disabled}
        occupiedRanges={occupiedRanges}
      />
      <div className="flex flex-col gap-1">
        <label className="text-[14px] font-semibold text-[#939393]">사유</label>
        <Textarea
          className="resize-none min-h-[64px] text-sm"
          placeholder="퇴사 관련 메모"
          value={memo ?? ""}
          onChange={(e) => onMemoChange(e.target.value)}
          disabled={(disabled ?? false) || !resignationDate}
        />
      </div>
    </div>
  );
}
